angular.module('bmsApp.directives')
	.directive('searchFilter', function ($timeout, $log) {
		return {
			restrict: 'A',
			scope: {method: '&onChange'},
			link: function (scope, elm, attrs) {
				var timeout = (angular.isUndefined(attrs.timeout)) ? 500 : attrs.timeout;

				var promise;
				elm.bind("keyup", function () {
					$timeout.cancel(promise);
					promise = $timeout(function () {
						scope.method();
					}, timeout);
				});

			}
		};
	});